import { PERMISSION_KEYS } from 'constants-permissions';
import { ALL_ACTIONS, READ_ONLY_ACTIONS } from '../Action';
import { hasAnyPermission, isSuperUser } from '../predicates';
import type { Resource } from '../Resource';
import { evaluateRules, type AccessRequest, type Rule } from '../Rule';

export const EQUIPMENT_RULES: readonly Rule<Resource>[] = [
  { name: 'superuser', actions: ALL_ACTIONS, appliesTo: isSuperUser },
  {
    name: 'admin',
    actions: ALL_ACTIONS,
    appliesTo: hasAnyPermission([PERMISSION_KEYS.PERMISSION_ADMIN]),
  },
  {
    name: 'add-edit',
    actions: ALL_ACTIONS,
    appliesTo: hasAnyPermission([
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_EQUIPMENT_ADD_EDIT,
    ]),
  },
  {
    name: 'view',
    actions: READ_ONLY_ACTIONS,
    appliesTo: hasAnyPermission([
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_EQUIPMENT_VIEW,
    ]),
  },
];

export const canAccessEquipmentAttachment = (
  request: AccessRequest<Resource>
): boolean => evaluateRules(EQUIPMENT_RULES, request);
